import { LOGIN_SUCCESS, LOGIN_FAIL, LOGOUT } from "../actions/actionTypes";

const user = JSON.parse(localStorage.getItem("user"));

const initialState = {
    isLoggedIn: user ? true : false,
    userData: user ? user : null,
    errorMessage: null,
    errorCode: null,
};

const loginSuccess = (state, action) => {
    const { payload } = action;
    return {
        ...state,
        isLoggedIn: true,
        userData: payload.user,
        errorMessage: null,
        errorCode: null,
    };
};

const loginFail = (state, action) => {
    const { payload } = action;
    return {
        ...state,
        isLoggedIn: false,
        userData: null,
        errorMessage: payload.errorMessage,
        errorCode: payload.errorCode,
    };
};

const logout = (state, action) => {
    return {
        ...state,
        isLoggedIn: false,
        userData: null,
        errorMessage: null,
        errorCode: null,
    };
};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return loginSuccess(state, action);
        case LOGIN_FAIL:
            return loginFail(state, action);
        case LOGOUT:
            return logout(state, action);
        default:
            return state;
    }
}
